// CCS Bundle Builder — variant-aware visibility
// Section renders on the 3 component PDPs (5100 case, microfiber 10pk blue, nitrile L 100/BX).
// On variant change, show only when the bundle's required variant is the one selected.
// CTA is a plain link to /products/foodservice-cleaning-kit (the standalone bundle PDP).

(function () {
  'use strict';

  function getCurrentVariantId() {
    var params = new URLSearchParams(window.location.search);
    var v = params.get('variant');
    if (v) return parseInt(v, 10);
    var input = document.querySelector('input[name="id"][type="hidden"], select[name="id"]');
    if (input && input.value) return parseInt(input.value, 10);
    var checked = document.querySelector('input[name="id"]:checked');
    if (checked && checked.value) return parseInt(checked.value, 10);
    return null;
  }

  function syncVariantVisibility() {
    var sections = document.querySelectorAll('[data-bundle-builder][data-required-variant-id]');
    if (!sections.length) return;
    var currentId = getCurrentVariantId();
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var requiredId = parseInt(section.dataset.requiredVariantId || '0', 10);
      if (!requiredId) continue;
      section.style.display = (currentId && currentId === requiredId) ? '' : 'none';
    }
  }

  function bindVariantWatchers() {
    var inputs = document.querySelectorAll('input[name="id"], select[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('change', syncVariantVisibility);
    }
    document.addEventListener('variant:change', syncVariantVisibility);
    window.addEventListener('popstate', syncVariantVisibility);
    var origPushState = history.pushState;
    history.pushState = function () {
      var ret = origPushState.apply(this, arguments);
      syncVariantVisibility();
      return ret;
    };
  }

  function init() {
    bindVariantWatchers();
    syncVariantVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
